export const tranTypeClass = [
    {tranType: "Monthly Total", class: " font-weight-bold"},
    {tranType: "Federal Income Tax", class: " font-weight-bold"},
    {tranType: "Federal Income Tax - Transfer", class: "font-weight-bold"},
    {tranType: "End of Year Account Balance", class: "font-weight-bold"},
    {tranType: "Current Account Balance", class: "font-weight-bold"},
    {tranType: "Balance Forward", class: "font-weight-bold"}
]
export default tranTypeClass;